import React, { useEffect } from 'react';
import './Classes.css';
import { useContext } from 'react';
import DataContext from '../context/DataContext';
const Condetions = () => {
  const {setNavtrans} = useContext(DataContext);
  useEffect(() => {
    setNavtrans(false);
  });
  return (
    <article className='container'>
      <div className='about'style={{width:"40%",height:"400px",overflowY:"scroll"}}>
        <h1>شروط الاستخدام</h1>
        <br/>
        <p></p>
        <br/>
        <p></p>
        <br/>
        <p></p>
        <br/>
       <p></p></div>
    </article>
  )
}

export default Condetions;